export const getPrevOrNextId = <T extends { id: number }>(newItem: T, oldItems?: T[]) => {
  if (!newItem || !oldItems) return undefined
  const deleteIndex = oldItems.findIndex(d => d.id === newItem?.id)
  const prevDashboardId = oldItems[deleteIndex - 1]?.id
  const nextDashboardId = oldItems[deleteIndex + 1]?.id
  return prevDashboardId || nextDashboardId
}
